import Skeleton from "../../../../shared/molecules/Skeleton/Skeleton";

const TaskItemSkeleton = () => (
  <li className="flex items-center px-3 py-3.5 my-2 rounded-lg cursor-pointer hover:bg-light-interactive-hover dark:hover:bg-hover-dark transition-all duration-200 mb-1 border-2 border-light-border-default dark:border-slate-700 shadow-sm hover:border-light-border-interactive dark:hover:border-transparent animate-pulse">
    {/* Status dot skeleton - matches w-2 h-2 rounded-full mr-3 transition-colors duration-200 */}
    <span className="w-2 h-2 rounded-full mr-3 bg-light-surfaceSecondary dark:bg-gray-600 transition-colors duration-200" />

    {/* Lock icon skeleton (conditional space) - matches FiLock text-red-400 mr-2 transition-colors duration-200 */}

    {/* Item name skeleton - matches flex-1 truncate text-base font-medium cursor-pointer transition-colors duration-200 */}
    <span className="flex-1 truncate text-base font-medium cursor-pointer transition-colors duration-200">
      <div className="h-4 bg-light-surfaceSecondary dark:bg-gray-600 rounded w-3/4" />
    </span>

    {/* Timeline icon skeleton - matches ml-2 HiOutlineChartBar size={18} cursor-pointer transition-colors duration-200 */}
  </li>
);

const DependencyCardSkeleton = () => (
  <div className="mb-4 rounded-xl border border-light-border-default dark:border-slate-700 bg-light-surfacePrimary dark:bg-secondary-dark shadow-sm p-0 overflow-hidden transition-all duration-300 animate-pulse">
    {/* Header: Name and expand/collapse arrow - matches px-4 pt-3 pb-1 */}
    <div className="flex items-center px-4 pt-3 pb-1">
      {/* Status dot skeleton - matches w-5 text-base */}
      <span className="w-5 text-base mr-3 flex-shrink-0 text-center">
        <div className="w-2 h-2 bg-light-surfaceSecondary dark:bg-gray-600 rounded-full mx-auto" />
      </span>
      {/* Name skeleton - matches flex-1 truncate font-semibold text-base */}
      <div className="flex-1 truncate">
        <div className="h-4 bg-light-surfaceSecondary dark:bg-gray-600 rounded w-2/3" />
      </div>
      {/* Expand arrow skeleton - matches ml-2 size={18} */}
      <div className="ml-2 w-[18px] h-[18px] bg-light-surfaceSecondary dark:bg-gray-600 rounded" />
    </div>

    {/* Status line: Lock, dependency badge, and action icons - matches px-4 pb-2 */}
    <div className="flex items-center gap-2 px-4 pb-2">
      {/* Lock icon skeleton */}
      <div className="w-4 h-4 bg-light-surfaceSecondary dark:bg-gray-600 rounded" />
      {/* Dependency badge skeleton - matches px-2 py-1 text-xs rounded-full */}
      <div className="px-2 py-1 bg-light-surfaceSecondary dark:bg-gray-700 rounded-full">
        <div className="h-3 bg-light-surfaceActive dark:bg-gray-700 rounded w-16" />
      </div>

      {/* Action icons skeleton - matches ml-auto flex items-center gap-2 */}
      <div className="ml-auto flex items-center gap-2">
        {/* Edit icon skeleton - matches p-1.5 rounded-md */}
        <div className="p-1.5 rounded-md">
          <div className="w-[14px] h-[14px] bg-light-surfaceSecondary dark:bg-gray-600 rounded" />
        </div>
        {/* Delete icon skeleton - matches p-1.5 rounded-md */}
        <div className="p-1.5 rounded-md">
          <div className="w-[14px] h-[14px] bg-light-surfaceSecondary dark:bg-gray-600 rounded" />
        </div>
      </div>
    </div>
  </div>
);

// Skeleton Components with global colors
const ProjectItemSkeleton = () => (
  <li className="flex items-center px-3 py-3.5 my-2 rounded-lg cursor-pointer hover:bg-light-interactive-hover dark:hover:bg-hover-dark transition-all duration-200 mb-1 border-2 border-light-border-default dark:border-slate-700 shadow-sm hover:border-light-border-interactive dark:hover:border-transparent animate-pulse">
    {/* Status dot skeleton - matches w-2 h-2 rounded-full mr-3 transition-colors duration-200 */}
    <span className="w-2 h-2 rounded-full mr-3 bg-light-surfaceSecondary dark:bg-gray-600 transition-colors duration-200" />

    {/* Lock icon skeleton (conditional space) - matches FiLock text-red-400 mr-2 transition-colors duration-200 */}

    {/* Item name skeleton - matches flex-1 truncate text-base font-medium cursor-pointer transition-colors duration-200 */}
    <span className="flex-1 truncate text-base font-medium cursor-pointer transition-colors duration-200">
      <div className="h-4 bg-light-surfaceSecondary dark:bg-gray-600 rounded w-3/4" />
    </span>

    {/* Timeline icon skeleton - matches ml-2 HiOutlineChartBar size={18} cursor-pointer transition-colors duration-200 */}
    <span className="ml-2 cursor-pointer transition-colors duration-200">
      <div className="w-[18px] h-[18px] bg-light-surfaceSecondary dark:bg-gray-600 rounded" />
    </span>
  </li>
);
// Simple skeleton list with fixed count
export const StrategymapSidePanelSkeleton = ({
  type = 'project',
}: {
  type?: 'project' |  'dependency' | 'milestone';
  containerRef?: React.RefObject<HTMLDivElement>;
}) => {
  const skeletonCount = type === 'dependency' ? 4 : 13;

  const SkeletonComponent =
    type === "dependency"
      ? DependencyCardSkeleton
      : type === "milestone"
        ? TaskItemSkeleton
        : ProjectItemSkeleton;

  return (
    <div
      className={`${type === "dependency" ? "px-3 mt-1 py-3" : type === "milestone" ? "mt-2" : ""}`}
    >
      {type === "project" ? (
        <ul className="mt-[-10px]">

          {Array.from({ length: skeletonCount }, (_, index) => (
            <SkeletonComponent key={index} />
          ))}
        </ul>
      ) : type === "milestone" ? (
        <div>
          {Array.from({ length: skeletonCount }, (_, index) => (
            <SkeletonComponent key={index} />
          ))}
        </div>
      ) : (
        <div>
          {Array.from({ length: skeletonCount }, (_, index) => (
            <SkeletonComponent key={index} />
          ))}
        </div>
      )}
    </div>
  );
};